import { loadLoginStatus, loadUserInfo, loadArrCosPlay, loadArrCosAward, loadLoginPcStatus} from '../../utils/cache'
import { saveLoginStatus, saveUserInfo, saveArrCosPlay, saveArrCosAward, saveLoginPcStatus} from '../../utils/cache'

const shengyaUser = {
  state: {
    loginStatus: loadLoginStatus(),//登录状态
    userInfo: loadUserInfo(),//用户登录信息
    arrCosPlay: loadArrCosPlay(), //每关完成状态
    arrCosAward: loadArrCosAward(), //每关完成状态
    loginPcStatus: loadLoginPcStatus() //pc端登录状态
  },

  mutations: {
    set_userInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    set_arrCosPlay(state, arrCosPlay) {
      state.arrCosPlay = arrCosPlay
    },
    set_arrCosAward(state, arrCosAward) {
      state.arrCosAward = arrCosAward
    },
    set_login_status(state, loginStatus) {
      state.loginStatus = loginStatus
    },
    set_Pclogin_status(state, loginPcStatus) {
      state.loginPcStatus = loginPcStatus
    },
  },

  actions: {
    //设置状态
    setLoginStatus(context, query) {
      // console.log('开始 state setLoginStatus query：'+query)
      context.commit('set_login_status', saveLoginStatus(query))
    },
    setPcLoginStatus(context, success) {
      // console.log('开始 state setLoginStatus query：'+query)
      context.commit('set_Pclogin_status', saveLoginPcStatus(success))
    },
    //保存用户个人信息
    setUserInfo(context, shengyaUser) {
      console.log('开始 state setUserInfo current: ' +Date.now())
      //先更新arrCosPlay、arrCosAward，写入store
      if(shengyaUser.arrCosPlay!=null){
        context.commit('set_arrCosPlay', saveArrCosPlay(shengyaUser.arrCosPlay))
      }
      if(shengyaUser.arrCosAward!=null){
        context.commit('set_arrCosAward', saveArrCosAward(shengyaUser.arrCosAward))
      }
      //再更新自身
      context.commit('set_userInfo', saveUserInfo(shengyaUser))
      //更新昵称到TIMSDK
    //   this.im.setMyProfile({
    //   	nick: shengyaUser.studentCollege + shengyaUser.studentName,
				// avatar: shengyaUser.headimgurl
    //   })
      //更新昵称到store.user
      // context.dispatch('updateNickname',shengyaUser.studentCollege + shengyaUser.studentName)
    },
    finishPlay(context,object) {
      console.log('开始 state finishPlay missionId：'+object.missionId)
			const partnerCode = context.state.userInfo.admin.manageAccCode.replace('admin','')
      const groupID = partnerCode+'-cos-mission-' + object.missionId
      const nickname = context.state.userInfo.studentCollege + context.state.userInfo.studentName
      // object.cosAnswer=object.cosAnswer.replace(/X/g,nickname)
      console.log(nickname+'-finish-'+object.cosAnswer)
      // const message = tim.createTextMessage({
      //   to: groupID,
      //   conversationType: 'GROUP',
      //   payload: { text: nickname+'-finish-'+object.cosAnswer}
      // })
      // tim.sendMessage(message).catch(error => {
      //   console.warn('sendMessage error:', error.message);
      // })
    },
  }
}

export default shengyaUser
